import {FormControl, FormGroup} from "@angular/forms";
import {Papa} from 'ngx-papaparse';
import {Injectable} from "@angular/core";
import {ConvertDobPipe} from "../pipes/convert-dob.pipe";
@Injectable({ providedIn: 'root' })
export class PatientSearchUtil {
  constructor(private papa: Papa) {}
  public parseMetadata(orgid: number, metadata: any): any {
    // for DEV LLU
    // this.abbyyForm.orgid === 102
    const data = {mrn: '', lname: '', fname: '', mname: '', dob: '', gender: ''};
    // let switchNames = false;
    // if (this.abbyyForm.orgid === 134 || this.abbyyForm.orgid === 135
    //   || this.abbyyForm.orgid === 136 || this.abbyyForm.orgid === 175) {
    //   switchNames = true;
    // }
    if (orgid === 102 || orgid === 71 || orgid === 134 || orgid === 136) {
      console.log('extracting metadata');
      let splitMetadata;
      if (metadata.includes(';')) {
        splitMetadata = metadata.split(';');
        data.mrn = splitMetadata[0];
        data.lname = splitMetadata[1];
        data.fname = splitMetadata[2];
        data.mname = splitMetadata[3];
        data.dob = splitMetadata[4];
        data.gender = splitMetadata[5];
      }
    }
    if (orgid === 118 || orgid === 117 || orgid === 94 || orgid === 89 || orgid === 167 || orgid === 140 || orgid === 114 || orgid === 115 || orgid == 78 || orgid == 65
      || orgid === 116 || orgid === 88 || orgid === 108 || orgid === 76 || orgid === 110 || orgid === 111) {
      let splitMetadata;
      this.papa.parse(metadata, {
        complete: (result) => {
          if (result.data.length === 1) {
            splitMetadata = result.data[0];
          } else {
            splitMetadata = result.data[1];
          }
        },
      });
      if (splitMetadata !== undefined && splitMetadata !== null) {
        data.mrn = splitMetadata[0];
        data.lname = splitMetadata[2];
        data.fname = splitMetadata[1];
        data.mname = splitMetadata[3];
        data.dob = splitMetadata[4];
        data.gender = splitMetadata[5];
      }
    }
    return data;
  }
  patchPatientFormWithMetadata(formMetadata: any, orgid: number) {
    const metadata = this.parseMetadata(orgid, formMetadata);
    let data= {mrn: '', lname: '', fname: '', mname: '', dob: null, gender: {}};
    // check for mrn
    if (metadata.mrn !== undefined && metadata.mrn !== 'null' && metadata.mrn.length > 0) {
      data.mrn = metadata.mrn;
    }
    // check for last name
    if (metadata.lname !== undefined && metadata.lname !== 'null' && metadata.lname.length > 0) {
      data.lname = metadata.lname;
    }
    // check for first name
    if (metadata.fname !== undefined && metadata.fname !== 'null' && metadata.fname.length > 0) {
      data.fname = metadata.fname;
    }
    // check for middle name
    if (metadata.mname !== undefined && metadata.mname !== 'null' && metadata.mname.length > 0) {
      data.mname = metadata.mname;
    }
    // check for DOB
    if (metadata.dob !== undefined && metadata.dob !== 'null' && metadata.dob.length > 0) {
          data.dob = new Date(metadata.dob + ' 12:00:00.000Z');
    }
    // check for gender
    if (metadata.gender !== undefined && metadata.gender !== 'null' && metadata.gender.length > 0) {
      if (metadata.gender === 'F' || metadata.gender === 'FEMALE') {
        data.gender = {text: 'Female', value: 'FEMALE'};
      } else if (metadata.gender === 'M' || metadata.gender === 'MALE') {
        data.gender = {text: 'Male', value: 'MALE'};
      } else if (metadata.gender === 'U' || metadata.gender === 'UNDIFFERENTIATED') {
        data.gender = {text: 'Undifferentiated', value: 'UNDIFFERENTIATED'};
      }
    }
    return data;
  }
  public static patchExtractedKeys(detectedKeys: any) {
    const data = {fname: '', lname: '', mrn: '', dob: null};
    if (detectedKeys.first_name !== undefined) {
      if (detectedKeys.first_name.value !== undefined) {
        data.fname = detectedKeys.first_name.value.content.trim();
      }
    }
    if (detectedKeys.last_name !== undefined) {
      if (detectedKeys.last_name.value !== undefined) {
        data.lname = detectedKeys.last_name.value.content.trim();
      }
    }
    if (detectedKeys.mrn !== undefined) {
      if (detectedKeys.mrn.value !== undefined) {
        data.mrn = detectedKeys.mrn.value.content.trim();
      }
    }
    if (detectedKeys.dob !== undefined) {
      if (detectedKeys.dob.value !== undefined) {
        const parsedDate = new Date(detectedKeys.dob.value.content.trim());
        // Check if valid and not "Invalid Date"
        if (!isNaN(parsedDate.getTime())) {
          data.dob = parsedDate;
        }
      }
    }
    return data;
  }
  public static patchClaudeDemographics(demographics: any) {
    const data = {fname: '', lname: '', mname: '', mrn: '', dob: null};
    if (demographics.patient_first_name !== undefined && demographics.patient_first_name !== null) {
      data.fname = demographics.patient_first_name.trim();
    }
    if (demographics.patient_last_name !== undefined && demographics.patient_last_name !== null) {
      data.lname = demographics.patient_last_name.trim();
    }
    if (demographics.patient_middle_name !== undefined && demographics.patient_middle_name !== null) {
      data.mname = demographics.patient_middle_name.trim();
    }
    if (demographics.mrn !== undefined && demographics.mrn !== null) {
      data.mrn = demographics.mrn.trim();
    }
    if (demographics.patient_date_of_birth !== undefined && demographics.patient_date_of_birth !== null) {
      const parsedDate = new Date(demographics.patient_date_of_birth.trim());
      // Check if valid and not "Invalid Date"
      if (!isNaN(parsedDate.getTime())) {
        data.dob = parsedDate;
      }
    }
    return data;
  }
    public static sortForms(forms: any[], type: any): any[] {
        if (type === 'ad') {
            return forms.sort((a, b) => {return +new Date(b.doc_date) - +new Date(a.doc_date);});
        } else {
            return forms.sort((a, b) => {return +new Date(b.created) - +new Date(a.created);});
        }
    }
    public static sanitizePatientForm(patientForm: FormGroup): any {
        const cleanPatient = {
            lname: PatientSearchUtil.cleanEmptyString(patientForm.get('lname')?.value),
            fname: PatientSearchUtil.cleanEmptyString(patientForm.get('fname')?.value),
            mname: PatientSearchUtil.cleanEmptyString(patientForm.get('mname')?.value),
            street: PatientSearchUtil.cleanEmptyString(patientForm.get('street')?.value),
            city: PatientSearchUtil.cleanEmptyString(patientForm.get('city')?.value),
            state: patientForm.get('state')?.value !== undefined && patientForm.get('state')?.value !== null ? patientForm.get('state')?.value.value : '',
            zip: PatientSearchUtil.cleanEmptyString(patientForm.get('zip')?.value),
            dob: PatientSearchUtil.toLocalDateString(PatientSearchUtil.cleanEmptyString(patientForm.get('dob')?.value)),
            gender: patientForm.get('gender')?.value !== undefined && patientForm.get('gender')?.value !== null ?
                patientForm.get('gender')?.value.value : '',
            phone: PatientSearchUtil.cleanEmptyString(patientForm.get('phone')?.value),
            mrn: PatientSearchUtil.cleanEmptyString(patientForm.get('mrn')?.value),
        };
        console.log('clean patient ', cleanPatient);
        return cleanPatient;
    }
    public static toLocalDateString(date: Date): string {
    return date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
  }
    public static getCleanPatient(patient: any) {
      patient.state = patient.state !== undefined && patient.state !== null ? patient.state.value : '';
      patient.gender = patient.gender !== undefined && patient.gender !== null ? patient.gender.value : '';
      return patient;
    }
    public static cleanEmptyString(value: any): any {
        if (value === undefined || value === null || value.length === 0) {
            return '';
        }
        return value;
    }
    public static compareStrings(str1: string, str2: string, isDate: boolean): string {
        if (isDate) {
          const date1 = ConvertDobPipe.prototype.transform(str1);
          const date2 = ConvertDobPipe.prototype.transform(str2);
          if (date1 === date2) {
            return '';
          } else {
            return 'mismatch'
          }
        } else {
            const s1 = (str1 ?? '').toString().trim().toLowerCase();
            const s2 = (str2 ?? '').toString().trim().toLowerCase();

            // If either string is empty or they don't match → mismatch
            if (!s1 || !s2 || s1 !== s2) {
                return 'mismatch';
            }
            return ''; // strings match
        }
    }
  public static formatDob(value: any): string | null {
    if (!value) return null;

    let date: Date;

    // If already a Date (Kendo DatePicker)
    if (value instanceof Date) {
      date = value;
    } else {
      // If string like "8/12/1994"
      const parts = value.split('/');
      if (parts.length === 3) {
        const [month, day, year] = parts;
        date = new Date(+year, +month - 1, +day);
      } else {
        return null;
      }
    }

    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();

    return `${mm}/${dd}/${yyyy}`;
  }
}
